import { Link } from "react-router-dom";
import { fileUrl } from "../lib/api";
import { Coins, BookOpen } from "lucide-react";

export default function BookCard({ book, action, testid, compact = false }) {
    return (
        <div data-testid={testid || `book-card-${book.id}`} className={`bg-white border border-parchment flex flex-col gap-3 rounded-xl shadow-book hover:-translate-y-1 hover:shadow-book-hover transition-all duration-300 ${compact ? "p-3" : "p-4"}`}>
            <div className="aspect-[3/4] bg-paper rounded-lg overflow-hidden border border-parchment relative">
                {book.cover_file_id ? (
                    <img src={fileUrl(book.cover_file_id)} alt={book.title} className="w-full h-full object-cover" />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-ink/30">
                        <BookOpen className="h-10 w-10" />
                    </div>
                )}
                {!book.is_available && (
                    <div className="absolute top-2 left-2 inline-flex px-2 py-0.5 rounded-full bg-ink/80 text-paper text-[10px] font-semibold uppercase tracking-wider">
                        Borrowed
                    </div>
                )}
            </div>
            <div className="flex-1 min-w-0">
                <div className={`font-serif font-semibold leading-snug line-clamp-2 ${compact ? "text-sm" : "text-lg"}`}>{book.title}</div>
                <div className={`text-ink/60 mt-0.5 truncate ${compact ? "text-xs" : "text-sm"}`}>by {book.author}</div>
                {book.owner && (
                    <div className="text-[10px] text-ink/50 mt-1.5 uppercase tracking-widest font-semibold">
                        {book.owner.name} · {book.owner.student_class}-{book.owner.section}
                    </div>
                )}
            </div>
            <div className="flex items-center justify-between gap-2">
                <div className={`inline-flex items-center gap-1 rounded-full bg-zapp/10 text-zapp-dark font-bold border border-zapp/20 ${compact ? "px-2 py-0.5 text-xs" : "px-3 py-1 text-sm"}`}>
                    <Coins className={compact ? "h-3 w-3" : "h-3.5 w-3.5"} />
                    {book.price_per_day}/day
                </div>
                {action}
            </div>
        </div>
    );
}
